import type { PropsWithChildren } from 'react';

import { cn } from '@/ui/utils/classnames';

type Props = PropsWithChildren<{ className?: string }>;

function SendSummary({ children, className }: Props) {
  return (
    <div
      className={cn(
        'rounded-2xl bg-gray-200 p-3 theme-dark:bg-neutral-600',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default SendSummary;
